import { ApiSchemaAppointmentByMonth } from "../../../models/api/appointment";
import { DashboardAppointment } from "../../appointment/dashboardAppointment";

type Props = {
  data?: ApiSchemaAppointmentByMonth[];
  isValidating: boolean;
};

export const CompanyAppointmentCalendar = (props: Props) => {
  return (
    <DashboardAppointment data={props.data} isValidating={props.isValidating} />
  );
};
